import React from "react";
import CustomTable from "../../../commons/CustomTable";
import AccordionIndividualService from "./AccordionIndividualService";
import PostSubscription from "./PostSubscription";

const Subscription = ({
  past_subscriptions,
  current_subscriptions,
  setIsId,
}) => {
  // Table Data
  const salesList = {
    data: current_subscriptions,
  };

  // Table Heading
  const ColumnHeaders = () => {
    return (
      <>
        <th
          scope="col"
          className="px-5 py-3 table_responsive_text border-b font-semibold text-left bg-primary_shades_light whitespace-nowrap "
        >
          Current Subscription
        </th>
        <th
          scope="col"
          className="px-5 py-2 table_responsive_text border-b font-semibold text-left bg-primary_shades_light"
        >
          Billing Cycle
        </th>
        <th
          scope="col"
          className="px-5 py-2 table_responsive_text border-b font-semibold text-left bg-primary_shades_light"
        >
          Period
        </th>
        <th
          scope="col"
          className="px-5 py-2 table_responsive_text border-b font-semibold text-left bg-primary_shades_light "
        >
          Action
        </th>
      </>
    );
  };

  // Table Row
  const DataRows = () => {
    return (
      <>
        {(salesList?.data || [])?.map((element, index) => (
          <AccordionIndividualService
            element={element}
            index={index}
            setIsId={setIsId}
          />
        ))}
      </>
    );
  };
  return (
    <div className="space-y-5">
      <div className="w-full bg-white border rounded">
        <CustomTable
          columnHeaders={<ColumnHeaders />}
          dataRows={<DataRows />}
          data={salesList}
          overflowVisibleLg={true}
          // loader
          loading={false}
          showPagination={false}
        />
      </div>
      <PostSubscription past_subscriptions={past_subscriptions} />
    </div>
  );
};

export default Subscription;
